import {
  getLocationsJobsSubscriptionChargesListQueryKey,
  getLocationsRetrieveQueryKey,
  useLocationsJobsSubscriptionResubscribeCreate,
} from "@sidegigllc/api/client";
import { useQueryClient } from "@tanstack/react-query";

/** Resubscribes the location, charging the first month now, then refreshes what that changes. */
export const useResubscribeJobsPlan = (locationId: number) => {
  const queryClient = useQueryClient();
  const resubscribe = useLocationsJobsSubscriptionResubscribeCreate();

  /** `onCharged` runs once the charge has gone through, before the refetch that changes what the plan offers. */
  const mutateAsync = async (onCharged?: () => void) => {
    await resubscribe.mutateAsync({ locationId });
    onCharged?.();
    // The first month is charged now, so the plan card's billing history changes too.
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: getLocationsRetrieveQueryKey(locationId) }),
      queryClient.invalidateQueries({ queryKey: getLocationsJobsSubscriptionChargesListQueryKey(locationId) }),
    ]);
  };

  return { mutateAsync, isPending: resubscribe.isPending };
};
